let lessons = null;
let progressBar = null;
let quizResultsLink = null;
let currentQuizItem = 1;
let answeredData = [];
let amountOfCorrectAnswers = 0;
window.dataLayer = window.dataLayer || [];

function hideAllPills() {
  const allPillLessonNumbers = document.querySelectorAll( '[data-pill-nr]' );

  [...allPillLessonNumbers].forEach( (pill) => {
    pill.style.display = 'none';
  } );
}

function startQuiz() {
  window.dataLayer.push( {
    'event': 'start-quiz',
  } );

  lessons[0].style.display = 'block';
  progressBar.querySelector( '.quiz-progress__max' ).textContent = lessons.length;
  showRandomQuestion( lessons[0], true );
  progress( 0 );

  hideAllPills();

  const firstPillLessonNumber = document.querySelector( '[data-pill-nr="1"]' );

  if (firstPillLessonNumber) {
    firstPillLessonNumber.style.display = 'block';
  }
}

function progress(value) {
  const allLessonImages = document.querySelectorAll( '[data-lesson-image-nr]' );
  const currentLessonImage = document.querySelector( '[data-lesson-image-nr="' + currentQuizItem + '"]' );
  progressBar.style.setProperty( '--current-quiz-progress', value + '%' );
  progressBar.querySelector( '.quiz-progress__current' ).textContent = currentQuizItem;

  hideAllPills();

  [...allLessonImages].forEach( (image) => {
    image.style.opacity = 0;
  } );

  if (currentLessonImage) {
    currentLessonImage.style.opacity = 1;
  }
}

function bindAnswering() {
  const allAnswers = document.querySelectorAll( '[data-answer]' );

  allAnswers.forEach( (answer) => {
    answer.addEventListener( 'click', (e) => {
      e.preventDefault();

      const lesson = e.target.closest( '[data-lesson]' );
      const nextLesson = lesson.nextElementSibling;
      const urlAppend = currentQuizItem === 1 ? "?d=" : "_";
      quizResultsLink.href = quizResultsLink.href + urlAppend + e.target.closest( '[data-answer]' ).dataset.answer;
      answeredData.push( e.target.dataset.answer );
      lesson.style.pointerEvents = 'none';

      if (e.target.closest( '[data-answer]' ).dataset.correct === 'true') {
        amountOfCorrectAnswers++;
      }

      if (nextLesson) {
        lesson.style.opacity = 0;
        lesson.style.translate = '0 1rem';
        nextLesson.style.translate = '0 -1rem';

        setTimeout( () => {
          lesson.style.display = 'none';
          nextLesson.style.display = 'block';
          progress( ++currentQuizItem * 100 / lessons.length );
          showRandomQuestion( nextLesson );

          setTimeout( () => {
            nextLesson.style.opacity = 1;
            nextLesson.style.translate = '0 0';
            nextLesson.style.pointerEvents = 'all';
          }, 250 );
        }, 250 );
      } else {
        window.dataLayer.push( {
          'event': 'end-quiz',
          'result': amountOfCorrectAnswers + '/' + lessons.length,
        } );

        quizResultsLink.click();
      }
    } );
  } );
}

function showRandomQuestion(lesson, onStart = false) {
  const allQuestions = lesson.querySelectorAll( '[data-question]' );
  const randomNumber = Math.floor( Math.random() * allQuestions.length );
  const pillLessonNumber = document.querySelector( '[data-pill-nr="' + currentQuizItem + '"]' );
  const splashAnswers = document.querySelectorAll( '[data-quiz-splash-answer]' );

  if (pillLessonNumber) {
    pillLessonNumber.style.display = 'block';
  }

  if (!allQuestions) {
    return;
  }

  const randomQuestion = allQuestions[randomNumber];
  randomQuestion.style.display = 'block';

  if (onStart && window.outerWidth > 1200) {

    if (document.body.classList.contains( 'page-animation' )) {
      // We have to do this scuffed thing because the height of the title is 0 when the element is hidden.
      document.querySelector( '[data-quiz-main]' ).style.display = 'block';
      document.querySelector( '[data-quiz-splash]' ).style.setProperty( '--first-question-header-height', randomQuestion.querySelector( '[data-quiz-main-title-span]' ).offsetHeight + 'px' );
      document.querySelector( '[data-quiz-main]' ).style.display = 'none';
      // End of scuffed thing.
    }

    document.querySelector( '[data-quiz-splash-title-span]' ).textContent = randomQuestion.querySelector( '[data-quiz-main-title-span]' ).textContent.trim();

    const allAnswers = randomQuestion.querySelectorAll( '[data-answer]' );

    if (!allAnswers) {
      return;
    }

    splashAnswers.forEach( (splashAnswer, index) => {
      splashAnswer.style.display = 'none';
    } );

    allAnswers.forEach( (answer, index) => {
      splashAnswers[index].style.display = 'block';
      index = index + 1;
      document.querySelector( '[data-quiz-splash-answer-text="' + index + '"]' ).textContent = answer.querySelector( '.lesson-question__text' ).textContent;
    } );
  }
}

export default {
  init() {
    // We have to reset all variables to prevent weird behaviour when navigating back to the page because barba.
    lessons = document.querySelectorAll( '[data-lesson]' );
    progressBar = document.querySelector( '.quiz-progress' );
    quizResultsLink = document.querySelector( '.quiz__results-link' );
    currentQuizItem = 1;
    answeredData = [];
    amountOfCorrectAnswers = 0;

    if (!lessons || !progressBar || !quizResultsLink) {
      return;
    }

    startQuiz();
    bindAnswering();
  },
};